var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCapsule = function SvgCapsule(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#191F2E",
    d: "M2.743 13.35 13.349 2.742a6 6 0 0 1 8.486 8.485L11.228 21.835a6 6 0 0 1-8.485-8.486m13.691 1.157 4.34-4.34a4.5 4.5 0 1 0-6.364-6.364l-4.34 4.34z"
  })));
};
export default SvgCapsule;